export default __webpack_public_path__ + "static/media/akustikdecken2.67b0a829.jpg";